import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    sessionStorage.removeItem("jwt");
    sessionStorage.removeItem("dbItem");
    new Cookies().remove("jwt", { path: "/" });
    navigate("/");
  }, [navigate]);

  return null;
};

export default Logout;